export default {
  primaryTextColor: '#474F5E',
  titleTextColor: '#242833',
  secondaryTextColor: '#7A8499',
  highlightColor: '#356DFF',
  dangerTextColor: '#F86140',
  primaryBorderColor: '#D7DBE7'
};